/* * * ./app/Ticket/Components/ticket.component.ts * * */
// Imports
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Ticket } from '../Model/ticket';
import { TicketService } from '../Services/ticket.service';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';

// Component decorator
@Component({
    moduleId: "module.id",
    selector: 'my-ticket-search',
    template: require('./views/ticket.component.html')
})
// Ticket class
export class TicketComponent {

    ticket_data: {};
    loading: boolean;
    errorMessage: string;
    success_message: boolean;
    client: {};
    ticket = new Ticket();

    // Constructor
    constructor(private router: Router, private ticketService: TicketService, config: NgbCarouselConfig){
        config.interval = 10000;
        config.wrap = false;
        config.keyboard = false;
    }

    ngOnInit() {
        this.ticket_data = this.ticketService.ticket_data;
        this.success_message = this.ticketService.success_message;
        this.client = this.ticketService.client;
    }

    searchTicket() {
        this.errorMessage = '';
        if (!this.ticket.id || !this.ticket.vrm ) { return; }
        if (this.success_message) { this.success_message = false;}
        this.loading = true;
        this.ticketService.searchTicket(this.ticket.id, this.ticket.vrm)
            .subscribe(
                ticket_data => {this.ticket_data = ticket_data; this.ticketService.ticket_data = ticket_data; },
                error => {this.errorMessage = error; this.loading = false},
                () => this.loading = false
            );
    }

    paymentRoute() {
        this.ticketService.ticket_data = this.ticket_data;
        let link = ['/payment'];
        this.router.navigate(link);
    }

 }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Ticket/Components/ticket.component.ts